import IValidatePasswordRecoveryCodeRepository from 'modules/authentication/domain/repositories/IValidatePasswordRecoveryCodeRepository';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisPasswordRecoveryCodeRepository from './implementations/VectisPasswordRecoveryCodeRepository';

let instance: IValidatePasswordRecoveryCodeRepository | null = null;

export default function makeVerificationCodeRepository() {
  if (!instance) {
    const httpProvider = makeHTTPProvider();

    instance = new VectisPasswordRecoveryCodeRepository(httpProvider);
  }

  return instance;
}
